export const BLOCK_CREATE = 'BLOCK_CREATE';
export const BLOCK_MOVE = 'BLOCK_MOVE';
export const BLOCK_RESIZE = 'BLOCK_RESIZE';

export const BLOCK_RESIZE_X1 = 'BLOCK_RESIZE_X1';
export const BLOCK_RESIZE_X2 = 'BLOCK_RESIZE_X2';
export const BLOCK_RESIZE_Y1 = 'BLOCK_RESIZE_Y1';
export const BLOCK_RESIZE_Y3 = 'BLOCK_RESIZE_Y2';

export const BLOCK_SELECT = 'BLOCK_SELECT';
